define('services/common/ajax/AppPromote',['app'], function (app) {
    app.factory('AppPromote', ['auiAjaxWithError', function (auiAjaxWithError) {
        return {
            queryTaskList: auiAjaxWithError.curryOld('AppPromote.CpService.queryTaskList'),
            reportPromoApp: auiAjaxWithError.curryOld('AppPromote.CpService.reportPromoApp'),
            queryPromoteApps: auiAjaxWithError.curryOld('AppPromote.CpService.queryPromoteApps'),
            reportPromoAppDown: auiAjaxWithError.curryOld('AppPromote.CpService.reportPromoAppDownload'),
            reportPromoAppBySearchKeys: auiAjaxWithError.curryOld('AppPromote.CpService.reportPromoAppBySearchKeys'),
            reportBySearchKeyDayDetail: auiAjaxWithError.curryOld('AppPromote.CpService.reportBySearchKeyDayDetail'),
            reportPromoAppSearchDown: auiAjaxWithError.curryOld('AppPromote.CpService.reportExportPromoAppBySearchKeys')
        }
    }])
});

